import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../environments/environment';

interface Scripts {
  name: string;
  src: string;
}

export const ScriptStore: Scripts[] = [
  { name: 'captcha', src: 'https://www.google.com/recaptcha/api.js' },
  { name: 'sound', src: environment.KUDOSHUB_SITE_URL + 'theme/js/sound-mouseover.js' }
];

// NOTE: We no longer need the `declare var document: any;` line

@Injectable({
  providedIn: 'root' // <-- 2. CHANGE THIS TO providedIn: 'root'
})
export class DynamicScriptLoaderService {

  private scripts: any = {};
  private isBrowser: boolean; // <-- ADD THIS

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { // <-- 3. INJECT PLATFORM_ID
    this.isBrowser = isPlatformBrowser(platformId); // <-- SET THE FLAG

    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src
      };
    });
  }

  load(...scripts: string[]) {
    // 4. If not in a browser, resolve immediately without doing anything.
    if (!this.isBrowser) {
      return Promise.resolve();
    }

    const promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      // This whole method is now implicitly browser-only because of the check in `load()`
      if (!this.scripts[name].loaded) {
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.scripts[name].src;
        script.onload = () => {
          this.scripts[name].loaded = true;
          resolve({ script: name, loaded: true, status: 'Loaded' });
        };
        script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
        document.getElementsByTagName('head')[0].appendChild(script);
      } else {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      }
    });
  }
}